import { render, staticRenderFns } from "./ImportPlants.vue?vue&type=template&id=34ef7477&"
import script from "./ImportPlants.vue?vue&type=script&lang=js&"
export * from "./ImportPlants.vue?vue&type=script&lang=js&"
import style0 from "./ImportPlants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports